var map = {
	"./tech-responsive-apache-airflow.svg": 4047,
	"./tech-responsive-artificial-intelligence.svg": 4048,
	"./tech-responsive-chatgpt.svg": 4049,
	"./tech-responsive-data.svg": 4050,
	"./tech-responsive-excel.svg": 4051,
	"./tech-responsive-git.svg": 4052,
	"./tech-responsive-google-sheets.svg": 4053,
	"./tech-responsive-jupyter.svg": 4054,
	"./tech-responsive-langchain.svg": 4055,
	"./tech-responsive-multiple.svg": 4056,
	"./tech-responsive-powerbi.svg": 4057,
	"./tech-responsive-powerpoint.svg": 4058,
	"./tech-responsive-python.svg": 4059,
	"./tech-responsive-r.svg": 4060,
	"./tech-responsive-sql.svg": 4061,
	"./tech-responsive-tableau.svg": 4062,
	"./tech-responsive-theory.svg": 4063
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3731;